export default __webpack_public_path__ + "static/media/ecosystem-members-link-img2-mob.bb19b731.png";